// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608070034/js/" + chunkId + "." + {"44":"0b5fb55f","225":"44579bc0","481":"520d448c","486":"0441695e","770":"f7eccc77"}[chunkId] + ".0.4227111842883663.chunk.js";
};